import gql from 'graphql-tag';

const CREATE_EVENT_GROUP = gql`
  mutation CreateEventGroup($data: CreateEventGroupInput!) {
    createEventGroup(data: $data) {
      id
      name
      workspaceId
      isDefault
      deviceTypes
    }
  }
`;

const UPDATE_EVENT_GROUP_BY_ID = gql`
  mutation UpdateEventGroupById($id: ID!, $data: UpdateEventGroupInput) {
    updateEventGroupById(id: $id, data: $data) {
      id
      name
      deviceTypes
      custom {
        id
        name
        deviceTypes
        workspaceId
      }
    }
  }
`;

const DELETE_EVENT_GROUP_BY_ID = gql`
  mutation DeleteEventGroupById($id: ID!) {
    deleteEventGroupById(id: $id) {
      id
      name
    }
  }
`;

export default {
  CREATE_EVENT_GROUP,
  UPDATE_EVENT_GROUP_BY_ID,
  DELETE_EVENT_GROUP_BY_ID,
};
